export default __webpack_public_path__ + "static/media/client2.3d329598.jpeg";